module.exports = __webpack_public_path__ + "static/media/turbo-games.9a056260.webp";